import { Spin } from 'antd';
import IconNoData from './../../../../assets/Images/icons/icon-no-data';
import entityIcon from '../../../../assets/Images/svg/entities-icon.svg'
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function RelatedEntities({ entities }) {
    const { t } = useTranslation();
    return (
        <div>
            <Spin spinning={!entities}>
                {entities && entities?.length > 0 ? (
                    <div className='space-y-2'>
                        {entities?.map((val) => (
                            <>
                                <div className='bg-[#F4F6FC] w-full space-y-1 py-3 px-[10px] rounded-md'>
                                    <div className='space-x-3 flex items-center'>
                                        <div className='font-semibold text-sm'>{val?.entityName}</div>
                                        <div className='flex items-center space-x-1 bg-[#FFEDD5] p-1 rounded-md'>
                                            <img
                                                alt={val?.entityGroup}
                                                src={entityIcon}
                                            />
                                            <div className='font-medium text-xs'>{val?.entityGroup}</div>
                                        </div>
                                    </div>
                                    <div className='font-normal text-[#65707A] text-sm'>
                                        {val?.entityData?.map((val,index)=>(
                                            <>{`${index !== 0 ? ' |':''} ${val?.data}`}</>
                                        ))}
                                    </div>
                                </div>
                            </>
                        ))}
                    </div>
                ) : (
                    <>
                        <div className="text-center text-sm space-y-2 my-32">
                            <IconNoData />
                            <p className="text-[#65707A] text-[14px]">
                                {t('No Data')}
                            </p>
                        </div>
                    </>
                )}
            </Spin>
        </div>
    );
}
